import React from 'react';
import { VBox } from '@/ui/shared-components/LayoutBoxes';
import { Typography } from '@mui/material';
import RegularButton from '@/ui/shared-components/buttons/RegularButton';
import theme from '@/theme';

const BenefitPageLinkButton = ({ link }) => {
    console.log('Rendering BenefitPageLinkButton with link:', link);

    return (
        <VBox
            sx={{
                maxWidth: 800,
                padding: { xs: 2, sm: 2 },
                backgroundColor: "transparent",
                border: "1px solid",
                borderColor: "blue.dark",
                boxShadow: '0px 1px 2px rgba(0, 0, 0, 0.25)',
                borderRadius: theme.shape.borderRadius,
                gap: 2,

            }}
        >
            <VBox sx={{ gap: 1 }} >
                <Typography variant="h4" sx={{ fontWeight: 500, wordBreak: "break-word" }}>
                    {link?.title}
                </Typography>
                <Typography variant="body1" sx={{ wordBreak: "break-word" }}>
                    {link?.description}
                </Typography>
                <RegularButton
                    variant="whiteOutlinedBlue"
                    size='small'
                    text={'Link öffnen'}
                    link={link?.url}
                />
            </VBox >
        </VBox >
    );
}

export default BenefitPageLinkButton;